const React = require('react')
const { useState, useEffect } = require('react')
const { Row, Col, UncontrolledTooltip } = require('reactstrap')
const { useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { ZERO_BYTES32, ZERO_ADDRESS } = require('@constants')

require('@styles/pages/block/mev.block.css')

const BlockMev = props => {
    const { loading, data } = props
    const { network } = useNetworkConfig()
    const isMobile = useResponsive(BREAKPOINTS.small)

    const [mevDetails, setMevDetails] = useState([])

    useEffect(() => {
        if (!data) return

        //Fake data
        const proposerFeeRecipient = ZERO_ADDRESS
        const mevReward = 0
        const mevPayoutTxnHash = ZERO_BYTES32

        const fields = {
            proposerFeeRecipient: {
                id: 'block-proposer-fee-recipient',
                label: 'Proposer Fee Recipient',
                value: (
                    <span
                        className={`${network.name}-text-color cursor-pointer`}
                        onClick={() => {
                            history.push(`/${network.name}/address/${proposerFeeRecipient}`)
                        }}
                    >
                        {proposerFeeRecipient}
                    </span>
                ),
                tooltip: "Block proposer's fee recipient."
            },
            mevReward: {
                id: 'block-mev-reward',
                label: 'MEV Reward',
                value: (
                    <>
                        {(mevReward / 10 ** 18).toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 18
                        })}
                        &nbswp;
                        {network.data.token}
                    </>
                ),
                tooltip: 'Reward sent to the block proposer.'
            },
            mevPayoutTxnHash: {
                id: 'block-mev-payout-txn-hash',
                label: 'MEV Payout Txn Hash',
                value: (
                    <span
                        className={`${network.name}-text-color cursor-pointer`}
                        onClick={() => {
                            history.push(`/${network.name}/tx/${mevPayoutTxnHash}`)
                        }}
                    >
                        {mevPayoutTxnHash}
                    </span>
                ),
                tooltip: 'Transaction hash of the on-chain reward sent to the block proposer.'
            }
        }

        const mevOrder = ['proposerFeeRecipient', 'mevReward', 'mevPayoutTxnHash']

        setMevDetails(mevOrder.map(key => fields[key]))
    }, [data])

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {mevDetails.map(item => (
                        <Row className='table-info-row' noGutters>
                            {item.id === 'divider' ? (
                                <div className='table-divider' />
                            ) : (
                                <>
                                    <Col xs={12} sm={4} className='d-flex align-items-start'>
                                        <span className='info-icon-wrapper' id={item.id}>
                                            <i className='fas fa-question-circle info-icon' />
                                        </span>
                                        <span className='info-label'>{item.label}:</span>
                                    </Col>
                                    <UncontrolledTooltip placement='top' target={item.id}>
                                        {item.tooltip}
                                    </UncontrolledTooltip>
                                    <Col
                                        xs={12}
                                        sm={8}
                                        className={`d-flex align-items-center ${isMobile && 'mt-2'}`}
                                        style={{ flexWrap: 'wrap', wordBreak: 'break-all' }}
                                    >
                                        <span className='info-value' style={{ width: '100%' }}>
                                            {item.value}
                                        </span>
                                    </Col>
                                </>
                            )}
                        </Row>
                    ))}
                </>
            )}
        </div>
    )
}

module.exports = { BlockMev }
